module.exports = __webpack_public_path__ + "img/chevron-double-left.926b1739.svg";